/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateScheduledReportRequest {
    name: string;
    screens: Array<CreateScheduledReportRequest.ScreensEnum>;
    filtersJson: string;
    frequency: CreateScheduledReportRequest.FrequencyEnum;
    recipients: Array<string>;
}
export namespace CreateScheduledReportRequest {
    export type ScreensEnum = 'OVERVIEW' | 'COVERAGE_DASHBOARD' | 'COVERAGE_ANALYSIS' | 'BRANDS' | 'TOPICS' | 'SENTIMENT' | 'MEDIA';
    export const ScreensEnum = {
        OVERVIEW: 'OVERVIEW' as ScreensEnum,
        COVERAGEDASHBOARD: 'COVERAGE_DASHBOARD' as ScreensEnum,
        COVERAGEANALYSIS: 'COVERAGE_ANALYSIS' as ScreensEnum,
        BRANDS: 'BRANDS' as ScreensEnum,
        TOPICS: 'TOPICS' as ScreensEnum,
        SENTIMENT: 'SENTIMENT' as ScreensEnum,
        MEDIA: 'MEDIA' as ScreensEnum
    };
    export type FrequencyEnum = 'WEEKLY' | 'MONTHLY';
    export const FrequencyEnum = {
        WEEKLY: 'WEEKLY' as FrequencyEnum,
        MONTHLY: 'MONTHLY' as FrequencyEnum
    };
}
